import { NgModule, ModuleWithProviders } from '@angular/core'
import { RouterModule } from '@angular/router'
import { OIDCClientConfig, OIDC_CLIENT_CONFIG } from './oidc-client-config'
import { StoreModule } from '@ngrx/store'
import { authFeatureKey, reducer } from './store/reducers/auth-reducers'
import { CommonComponentsModule } from 'common-components'
import { EffectsModule } from '@ngrx/effects'
import { SessionEffects } from './store/effects/session-effects'
import { LoginComponent } from './components/login/login.component'
import { LogoutComponent } from './components/logout/logout.component'

@NgModule({
  declarations: [LoginComponent, LogoutComponent],
  imports: [
    StoreModule.forFeature(authFeatureKey, reducer),
    EffectsModule.forFeature([SessionEffects]),
    CommonComponentsModule
  ],
  exports: [RouterModule, LoginComponent, LogoutComponent],
  providers: []
})
export class NgClientAuthModule {
  public static forRoot(config: OIDCClientConfig): ModuleWithProviders<NgClientAuthModule> {
    return {
      ngModule: NgClientAuthModule,
      providers: [
        {
          provide: OIDC_CLIENT_CONFIG,
          useValue: config
        }
      ]
    }
  }
}
